

//引入
import request from "../utils/request";
const api = {
    //违建报告
    wjbgquerylist: function (params) {

        return request({

            method: "get",
            params,
            url: "middlescreen/api/zhwyzszx/wjbgquerylist",
        });
    },

    //装修巡检
    zxxjquerylist: function (params) {

        return request({

            method: "get",
            params,
            url: "middlescreen/api/zhwyzszx/zxxjquerylist",
        });
    },
    //正在装修
    zzzxquerylist: function (params) {

        return request({

            method: "get",
            params,
            url: "middlescreen/api/zhwyzszx/zzzxquerylist",
        });
    },

}

export default api;